import React, { useState } from "react";
import PropTypes from "prop-types";
import { Formik, Form, Field, FieldArray } from "formik";
import TextField from "@material-ui/core/TextField";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CloseIcon from "@material-ui/icons/Close";
import Modal from "react-bootstrap/Modal";
import { Button, Radio } from "@material-ui/core";
import FormStepper from "../FormStepper";
import axios from "axios";
import "../../AddEstablishedPers/AddEstablishedPers.css";
import { DatePicker } from "../../Pers-atoms";

export const PersStatus = ({
  formData,
  setFormData,
  nextStep,
  prevStep,
  step,
  persId,
  projectId,
  selectedPhaseList,
}) => {
  console.log(formData);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const passData = JSON.parse(sessionStorage.getItem("passData"));
  const [disable, setDisable] = useState(false);
  let [persDecisionData, setPersDecisionData] = React.useState("");
  let [persStatus, setPersStatus] = React.useState("");
  let [expirationList, setExpirationList] = React.useState([]);
  const fetchPersDecisionData = React.useCallback(() => {
    axios
      .get(
        global.REACT_APP_API_ENDPOINT + `/decision/getPersDecisionAndExpiration`
      )
      .then((response) => {
        setPersDecisionData(response.data);
      })
      .catch((error) => {
        throw Error(error);
      });
  }, []);

  React.useEffect(() => {
    // fetchPersStatusData();
    fetchPersDecisionData();
  }, [fetchPersDecisionData]);

  const persStatusList = Object.keys(persDecisionData).map((key) => key);

  function expirationChanged(data) {
    setApiErr("");

    if (!data.persExpiration) {
      setExpErr("Required");
    } else {
      setExpErr("");
    }
  }

  function specificDateChanged(data) {
    setApiErr("");

    if (!data.dtSpecificDate) {
      setDateErr("Required");
    } else {
      setDateErr("");
    }
  }

  function statusChanged(event, data) {
    setExpErr("");
    setDateErr("");
    setApiErr("");
    setStatusErr("");

    setPersStatus(event.target.value);
    if (event.target.value != "") {
      Object.keys(persDecisionData).map((key) => {
        if (key == event.target.value) {
          setExpirationList(persDecisionData[key]);
        }
      });
    } else {
      setExpirationList([]);
    }
  }

  const [phasePersStatus, setPhasePersStatus] = useState([]);
  const [phasePersExpiration, setPhasePersExpiration] = useState([]);
  const [dtSpecificDate, setDtSpecificDate] = useState([]);
  let [phaseExpirationList, setPhaseExpirationList] = React.useState([]);

  function setPhaseExpirationData(event, index, values) {
    setApiErr("");

    phasePersStatus[index] = event.target.value;
    phasePersExpiration[index] = "";

    setPhasePersExpiration((prevExpiry) => ({
      ...prevExpiry,
      phasePersExpiration,
    }));

    if (event.target.value !== "") {
      Object.keys(persDecisionData).map((key) => {
        if (key == event.target.value) {
          phaseExpirationList[index] = persDecisionData[key];
          setPhaseExpirationList((prevExpiry) => ({
            ...prevExpiry,
            phaseExpirationList,
          }));
        }
      });
    } else {
      phaseExpirationList[index] = [];
      setPhaseExpirationList((prevExpiry) => ({
        ...prevExpiry,
        phaseExpirationList,
      }));
    }

    // checkOnchangeValidation(values, index);
  }

  const [apiErr, setApiErr] = useState("");
  const [emptyErr, setEmptyErr] = useState("");

  const [statusErr, setStatusErr] = useState("");
  const [expErr, setExpErr] = useState("");
  const [dateErr, setDateErr] = useState("");

  function savePersDecision(data) {
    setIsSubmitted(true);

    let statusErr = "";
    let dateErr = "";
    let expErr = "";

    if (!persStatus) {
      statusErr = "Required";
    }

    if ((!data.persExpiration) && (persStatus === "Final Project Approval" || persStatus === "Conditional/Available" || persStatus === "Conditional/Unavailable")) {
      expErr = "Required";
    }

    if (data.persExpiration === "Enter Specific date") {
      dateErr = getDateError(data.dtSpecificDate);
    }

    setStatusErr(statusErr);
    setDateErr(dateErr);
    setExpErr(expErr);

    if (!statusErr && !dateErr && !expErr) {
      if (data.projectReasonError === 'valid' || persStatus !== "Ineligible" && persStatus !== "Conditional/Unavailable") {
        checkRedirection(data);
      }
    }
  }

  function checkPhaseExpiryValidation(data, index) {
    let arr = [];
    let i = 0;
    setApiErr("");

    setEmptyErr("");

    if (
      phasePersStatus[index] == "Ineligible" ||
      phasePersStatus[index] == "Suspension of the Application"
    ) {
      phasePersExpiration[index] = "NA";
    }

    for (let phase of selectedPhaseList) {
      if (
        (phasePersStatus[i] && !phasePersExpiration[i]) ||
        (phasePersStatus[i] !== "" && phasePersExpiration[i] === "")
      ) {
        if (
          phasePersStatus[i] !== "Ineligible" ||
          phasePersStatus[i] !== "Suspension of the Application"
        ) {
          phase.expError = "Please select expiration date";
        }
      } else {
        phase.expError = "";
      }

      let obj = {
        persDecison: phasePersStatus[i],
        persExpiration: dtSpecificDate[i]
          ? dtSpecificDate[i]
          : phasePersExpiration[i],
        phaseId: phase.value,
      };
      arr.push(obj);
      i++;
    }

    data.phaseDecisions = arr;
  }

  function checkPhaseDtValidation(data, index) {
    let arr = [];
    let i = 0;
    setApiErr("");

    for (let phase of selectedPhaseList) {
      if (phasePersExpiration[i] == "Enter Specific date") {
        if (!dtSpecificDate[i]) {
          phase.dtError = "Please select specific date";
        } else {
          phase.dtError = "";
        }
      } else {
        dtSpecificDate[i] = "";
      }

      let obj = {
        persDecison: phasePersStatus[i],
        persExpiration: dtSpecificDate[i]
          ? dtSpecificDate[i]
          : phasePersExpiration[i],
        phaseId: phase.value,
      };
      arr.push(obj);
      i++;
    }

    data.phaseDecisions = arr;

    console.log("selectedPhaseList = >> ", selectedPhaseList);
  }

  function savePhaseDecision(data) {
    console.log("data >>", data);
    console.log("phasePersStatus >>", phasePersStatus);
    console.log("phasePersExpiration ?>>", phasePersExpiration);

    let arr = [];
    let i = 0;
    setApiErr("");
    if (phasePersStatus.length <= 0) {
      setEmptyErr("Please select atleast one phase decision");
    } else {
      let f = 0;
      for (let decision of phasePersStatus) {
        if (decision == "") {
          f++;
        }
      }

      if (phasePersStatus.length == f) {
        setEmptyErr("Please select atleast one phase decision");
      } else {
        setEmptyErr("");
        for (let phase of selectedPhaseList) {
          if (
            (phasePersStatus[i] && !phasePersExpiration[i]) ||
            (phasePersStatus[i] !== "" && phasePersExpiration[i] === "")
          ) {
            if (
              phasePersStatus[i] !== "Ineligible" ||
              phasePersStatus[i] !== "Suspension of the Application"
            ) {
              phase.expError = "Please select expiration date";
            }
          } else {
            if (phasePersExpiration[i] == "Enter Specific date") {
              if (!dtSpecificDate[i]) {
                phase.dtError = "Please select specific date";
              } else {
                phase.dtError = "";
              }
            } else {
              dtSpecificDate[i] = "";
              phase.expError = "";
            }
          }

          let obj = {
            persDecison: phasePersStatus[i],
            persExpiration: dtSpecificDate[i]
              ? dtSpecificDate[i]
              : phasePersExpiration[i],
            phaseId: phase.value,
          };
          arr.push(obj);
          i++;
        }

        data.phaseDecisions = arr;
        let flag = false;
        for (let phase of selectedPhaseList) {
          if (phase.expError || phase.dtError) {
            flag = true;
          }
        }

        if (flag == false) {
          callSaveDecision(data);
        }
      }
    }

    console.log("selectedPhaseList = >> ", selectedPhaseList);
  }

  function callSaveDecision(data) {
    let params = {
      createdById: passData.user,
      persId: persId,
      persProjectDecison: persStatus,
      persProjectExpiration: data.dtSpecificDate
        ? data.dtSpecificDate
        : data.persExpiration,
      // dtSpecificDate: data.dtSpecificDate,
      phaseDecisions: data.phaseDecisions,
      projectId: projectId,
      reviewedBy: "Test reviewer",
    };

    console.log("params =>> ", params);
    axios
      .post(
        global.REACT_APP_API_ENDPOINT + `/decision/saveNewPersDecision`,
        params
      )
      .then((response) => {
        console.log("save decision response", response);
        if (response.status == 200) {
          setApiErr("");
          // setPersId(response.data);
          setTimeout(() => {
            nextStep();
          }, 300);
        } else if (response.data && response.data.message) {
          if (response.data.message == "Internal server error") {
            window.location.href = "/error-page";
          } else {
            setApiErr(response.data.message);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Formik
        initialValues={formData}
        onSubmit={(values) => {
          // values.persStatus = persStatus;
          // setFormData(values);
          // savePersDecision(values);
        }}
      >
        {({ values, errors, touched }) => (
          <Form className="parent-form">
            <FormStepper step={step} />
            <div className="field-container">
              <div className="top-title-container">
                <div className="big-title">Add New PERS Request</div>
                <div className="small-title">
                  For Condo Project: {values.projectId}
                </div>
              </div>

              {values.decisionLevel == "Entire Project" ? (
                <div className="success-lower-container">
                  <div className="section-title">
                    Section 7 of 9 - PERS Decision : Overall Project
                  </div>
                  <div className="attribute-title">
                    PERS Decision<span style={{ color: "red" }}>*</span>
                  </div>
                  <div className="attribute-select">
                    <select
                      // required
                      name="persStatus"
                      id={"id"}
                      className="attribute-select-dropdown select-decision"
                      value={persStatus}
                      onChange={(event) => {
                        values.persStatus = event.target.value;
                        values.persExpiration = "";
                        statusChanged(event, values);
                      }}
                    >
                      <option value="">Select PERS Status</option>
                      {persStatusList.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                    {/* </Field> */}
                    {statusErr ? (
                      <div style={{ color: "red" }}>{statusErr}</div>
                    ) : null}
                  </div>
                  <div className="attribute-title">
                    Expiration<span style={{ color: "red" }}>*</span>
                  </div>
                  <div className="attribute-select">
                    {persStatus == "Ineligible" ||
                    persStatus == "Suspension of the Application" ? (
                      <div>{(values.persExpiration = "NA")}</div>
                    ) : (
                      // <Field
                      //   className="attribute-select-dropdown"
                      //   name="persExpiration"
                      //   as="select"
                      //   validate={validateText}
                      // >
                      <select
                        // required
                        name="persExpiration"
                        id={"id"}
                        className="attribute-select-dropdown select-decision"
                        value={values.persExpiration}
                        onChange={(event) => {
                          values.persExpiration = event.target.value;
                          values.dtSpecificDate = "";

                          setFormData((prevExpiry) => ({
                            ...prevExpiry,
                            values,
                          }));

                          expirationChanged(values);
                        }}
                      >
                        <option value="">Expiration</option>
                        {expirationList
                          ? expirationList.map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                            ))
                          : null}
                      </select>
                      // {/* </Field> */}
                    )}

                    {expErr ? (
                      <div style={{ color: "red" }}>{expErr}</div>
                    ) : null}
                  </div>
                  <div className="attribute-select">
                    {values.persExpiration === "Enter Specific date" && (
                      <div className="field">
                        <DatePicker
                          label=""
                          name="dtSpecificDate"
                          formData={formData}
                          handleChange={(e) => {
                            values.dtSpecificDate = e.target.value;

                            setFormData((prevExpiry) => ({
                              ...prevExpiry,
                              values,
                            }));

                            specificDateChanged(values);
                          }}
                          isEdit
                        />
                      </div>
                    )}
                    {dateErr ? (
                      <div style={{ color: "red" }}>{dateErr}</div>
                    ) : null}
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      color: "#ff0000",
                      padding: 15,
                    }}
                  >
                    {apiErr ? apiErr : null}
                  </div>
                  <div className="bottom-button-container">
                    <Button
                      type="submit"
                      className="next-button next-btn-save"
                      disabled={disable}
                      onClick={() => {
                        setDisable(true);
                        savePersDecision(values);
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      type="submit"
                      className="next-button next-btn-save"
                      onClick={() => {
                        nextStep();
                      }}
                    >
                      Skip
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="success-lower-container">
                  <div className="section-title">
                    Section 7 of 9 - PERS Decision : Phases
                  </div>

                  <div className="phase-data-container">
                    <div className="phase-data-sub-container">
                      <div className="phase-data-title">Phases Selected</div>
                    </div>
                    <div className="phase-data-sub-container">
                      <div className="phase-data-title">Pers Decision</div>
                    </div>
                    <div className="phase-data-sub-container">
                      <div className="phase-data-title">Expiration</div>
                    </div>
                  </div>
                  {selectedPhaseList.map((option, index) => (
                    <div>
                      <div className="phase-data-container">
                        <div className="phase-data-sub-container">
                          <div className="phase-data-title">{option.name}</div>
                        </div>
                        <div className="phase-data-sub-container">
                          <div className="phase-data-title">
                            <select
                              // required
                              name="persStatus"
                              id={index}
                              className="attribute-select-dropdown"
                              value={phasePersStatus[index]}
                              onChange={(event) => {
                                setPhaseExpirationData(event, index, values);
                                option.expError = "";
                              }}
                            >
                              <option value="">Select PERS Status</option>
                              {persStatusList.map((option, index) => (
                                <option key={index} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="phase-data-sub-container">
                          <div className="phase-data-title">
                            {phasePersStatus[index] == "Ineligible" ||
                            phasePersStatus[index] ==
                              "Suspension of the Application" ? (
                              <div>{(phasePersExpiration[index] = "NA")}</div>
                            ) : (
                              <select
                                // required
                                name="phasePersExpiration"
                                id={index}
                                className="attribute-select-dropdown"
                                value={phasePersExpiration[index]}
                                onChange={(event) => {
                                  phasePersExpiration[index] =
                                    event.target.value;
                                  option.dtError = "";

                                  setPhasePersExpiration((prevExpiry) => ({
                                    ...prevExpiry,
                                    phasePersExpiration,
                                  }));

                                  checkPhaseExpiryValidation(values, index);
                                  // checkOnchangeValidation(values, index);
                                  // setPhasePersExpiration(phasePersExpiration);
                                }}
                              >
                                <option value="">Expiration</option>
                                {phaseExpirationList[index]
                                  ? phaseExpirationList[index].map(
                                      (option, index) => (
                                        <option key={index} value={option}>
                                          {option}
                                        </option>
                                      )
                                    )
                                  : null}
                              </select>
                            )}
                            {/* </Field> */}
                            {option.expError ? (
                              <div
                                style={{
                                  textAlign: "left",
                                  color: "#ff0000",
                                  fontWeight: "normal",
                                  // paddingRight: 20
                                }}
                              >
                                {option.expError}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="phase-data-sub-container">
                          <div className="">
                            {phasePersExpiration[index] ===
                              "Enter Specific date" && (
                              <div className="">
                                <DatePicker
                                  label=""
                                  name="dtSpecificDate"
                                  formData={formData}
                                  handleChange={(event) => {
                                    // values.dtSpecificDate = e.target.value;
                                    dtSpecificDate[index] = event.target.value;

                                    setDtSpecificDate((prevExpiry) => ({
                                      ...prevExpiry,
                                      dtSpecificDate,
                                    }));

                                    checkPhaseDtValidation(values, index);
                                  }}
                                  isEdit
                                />
                              </div>
                            )}
                          </div>
                          {option.dtError ? (
                            <div
                              style={{
                                textAlign: "left",
                                color: "#ff0000",
                                // paddingRight: 20
                              }}
                            >
                              {option.dtError}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ))}
                  <div
                    style={{
                      textAlign: "right",
                      color: "#ff0000",
                      padding: 15,
                    }}
                  >
                    {apiErr ? apiErr : null}
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      color: "#ff0000",
                      padding: 15,
                    }}
                  >
                    {emptyErr ? emptyErr : null}
                  </div>
                  <div className="bottom-button-container">
                    <Button
                      type="submit"
                      className="next-button next-btn-save"
                      onClick={() => {
                        savePhaseDecision(values);
                      }}
                    >
                      Save
                    </Button>

                    <Button
                      type="submit"
                      className="next-button next-btn-save"
                      onClick={() => {
                        nextStep();
                      }}
                    >
                      Skip
                    </Button>
                    {/* <Button
                      type="submit"
                      className="previous-button"
                      onClick={() => prevStep()}
                    >
                      <ArrowBackIcon />
                      Previous Section
                    </Button> */}
                  </div>
                </div>
              )}
            </div>
            <div className="right-cancel-container">
              <Button className="cancel-pers-button" onClick={handleShow}>
                <CloseIcon style={{ fill: "red" }} />
                Cancel PERS Request
              </Button>
              <Modal show={show} className="my-modal" onHide={handleClose}>
                <Modal.Header className="the-modal-header" closeButton>
                  <Modal.Title className="the-modal-title">
                    Cancel PERS Request
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="the-modal-body">
                  All of your progress will be lost. Are you sure you want to
                  cancel?
                </Modal.Body>
                <Modal.Footer className="the-modal-footer">
                  <Button className="go-back-button" onClick={handleClose}>
                    Go Back
                  </Button>
                  <Button className="cancel-modal-button" href={`/`}>
                    Cancel PERS Request
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

PersStatus.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
};
